import { Trans } from '@sortlist-frontend/translation/ssr';

import { SectionsDetails } from '_features/AgencyProfile/components/SectionsDetails';
import * as S from '_features/AgencyProfile/components/ServicesPanel/styles';
import type { Section } from '_features/AgencyProfile/utils';

import type { ServiceClient } from './types';

interface Props {
  serviceName: string;
  clients: ServiceClient[];
  className?: string;
  handleActivePanel: (value: Section | undefined) => void;
}

export const ServiceClients = (props: Props) => {
  const { className, clients, serviceName, handleActivePanel } = props;
  const maxNumberOfCardsDisplayed = 4;

  return (
    <section className={`${className} p-4 layout-column`}>
      <header className="p-2">
        <Trans i18nKey={'agency:profile.services.clientsTitle'} count={clients.length}>
          <b>Clients</b> in {{ serviceName }} ({{ count: clients.length }})
        </Trans>
      </header>
      <div className="flex-1 layout-row p-2">
        <div className="flex-1 layout-row layout-wrap">
          {clients.slice(0, maxNumberOfCardsDisplayed).map((client, index) => (
            <div key={`${client.name}-${index}`} className="pr-2 pb-2 flex-xs-100 flex-sm-33 flex-gt-sm-20 layout-row">
              <div className="shadow-2 flex-1 p-2 rounded-sm bg-neutral-50 layout-column">
                <span className="small bold mb-1">{client.name}</span>
                <span className="small italic text-secondary-500">
                  {client.sector} {client.marketSize != null && `| ${client.marketSize}`}
                </span>
              </div>
            </div>
          ))}
          {clients.length > maxNumberOfCardsDisplayed && (
            <div className="pr-2 pb-2 flex-xs-100 flex-sm-33 flex-gt-sm-20 layout-row layout-align-start-stretch">
              <S.ItemExpand
                buttonStyle="secondary"
                size="lg"
                className="layout-fill bg-secondary-200 text-secondary-500"
                onClick={() => handleActivePanel(SectionsDetails?.find((section) => section.id === 'portfolio'))}
                label={`+${clients.length - maxNumberOfCardsDisplayed}`}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
